import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";

interface IProps {
  minHeight?: string;
}

const LoadingSpinner: React.FC<IProps> = ({ minHeight = "0" }: IProps) => {
  return (
    <Grid
      container
      style={{ minHeight }}
      justify={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Grid>
  );
};

export default LoadingSpinner;
